<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :title="$t('ROON锁仓.ROON锁仓')" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class="lock-item1-bg-image p-40">
					<div class="flex items-center justify-between">
						<div class="flex items-center">
							<span class="text-40 font-bold text-white">{{$t('ROON锁仓.ROON锁仓')}}</span>
						</div>
						<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
							style="border-color: #EB470C; background-color: #EB470C20;">
							<div class="w-8 h-8 rounded-full" style="background-color: #EB470C;"></div>
							<span class="ml-10 text-20" style="color: #EB470C;">{{$t('ROON锁仓.线性解锁')}}</span>
						</div>
					</div>
					<div class="mt-20">
						<span class="text-24 text-#ccc">{{$t('ROON锁仓.安全锁仓 · 线性解锁 · 随时提取')}}</span>
					</div>
					<div class="mt-30 flex items-center">
						<img class="w-22 h-22" src="@/assets/images/pages/lock/aq.png" alt="" />
						<span class="ml-10 text-24 text-#ccc">{{$t('ROON锁仓.安全锁仓')}}</span>
						<img class="ml-20 w-22 h-22" src="@/assets/images/pages/lock/js.png" alt="" />
						<span class="ml-10 text-24 text-#ccc">{{$t('ROON锁仓.线性解锁')}}</span>
					</div>
				</div>
				<div class="mt-30 p-30 lock-item2-bg-image" style="background-color: #280D03;">
					<div class="flex items-center justify-center">
						<span class="text-24 text-#ccc">RGT锁仓</span>
					</div>
					<div class="flex items-center justify-center py-20">
						<img class="w-50 h-50" src="@/assets/images/pages/lock/logo.png" alt="" />
						<span class="ml-10 text-60 text-primary font-blod">{{all_surplus_roon}}</span>
					</div>
					<div class="flex items-center justify-center">
						<span class="text-24 text-#ccc">ROON</span>
					</div>
					<!-- <div class="mt-20 flex items-center justify-between">
						<span class="text-24 text-#ccc">{{$t("ROON锁仓.解锁进度")}}</span>
						<span class="text-24 text-primary">100%</span>
					</div>
					<div class="mt-20 h-20 rounded-full" style="background-color: #391508;">
						<div class="mt-20 h-20 rounded-full bg-primary" style=" width: 30%;">

						</div>
					</div> -->

					<div class="mt-30 flex items-center justify-between">
						<div class="w-290 p-30 rounded-20" style="background-color: #391304;">
							<div class="flex items-center justify-between">
								<span class="text-24 text-#ccc">节点锁仓</span>
							</div>
							<div class="mt-20">
								<span class="text-46 font-bold" style="color: #EB470C;">{{roon}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#eee">ROON</span>
							</div>
						</div>
						<div class="w-290 p-30 rounded-20" style="background-color: #391304;">
							<div class="flex items-center justify-between">
								<span class="text-24 text-#ccc">{{$t("ROON锁仓.已解锁")}}</span>
							</div>
							<div class="mt-20">
								<span class="text-46 font-bold" style="color: #EB470C;">{{already_roon}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#eee">ROON</span>
							</div>
						</div>
					</div>
					<div class="jieya">
						<div class="jieyabtn" @click="getjieyaClick(1)">{{$t("解押NFT")}}</div>
						<div class="jieyabtn zhiya" @click="getjieyaClick(2)">{{$t("质押NFT")}}</div>
					</div>
				</div>
				<div class="mt-20 bg-white/10 rounded-20 p-20 flex items-center">
					<img class="w-88 h-88" src="@/assets/images/pages/lock/qb.png" alt="" />
					<div class="ml-20 flex-1">
						<div class="flex items-center justify-between">
							<div>
								<span class="text-28 text-white">ROON余额</span>
							</div>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div>
								<span class="text-40 text-primary font-blod">{{roon_balance}}</span>
							</div>
							<div>
								<span class="text-24 text-#999" >ROON</span>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-20 bg-white/10 rounded-20 p-30">
					<div class="">
						<span class="text-36 text-white font-bold">{{$t("ROON锁仓.提取ROON")}}</span>
					</div>
					<div class="mt-20 h-110 rounded-20 flex items-center justify-between px-30"
						style="background-color: #0F0F10;">
						<input class="flex-1 text-32 text-white" v-model="withdrawal_number" @input="handleWithdrawalInput" type="text" :placeholder="$t('ROON锁仓.输入提取数量')" />
						<span class="text-32 text-primary" style="color: #EB470C;">ROON</span>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<span class="text-24 text-#999">{{$t("闪兑.最低")}} 1 ROON</span>
						<div class="flex items-center">
							<span class="text-24 text-#999">{{$t("闪兑.余额")}}</span>
							<span class="text-24" style="color: #EB470C;">{{roon_balance}}</span>
						</div>
					</div>
<!--					<div class="mt-20 flex items-center justify-between">-->
<!--						<div @click="form.amount = item.num" v-for="(item, index) in numberList" :key="index"-->
<!--							:class="[form.amount == item.num ? 'bg-primary text-white' : 'bg-#1B1B1B text-#ccc']"-->
<!--							class="w-150 h-80 rounded-20 flex items-center justify-center ">-->
<!--							<span class="text-28">{{item.num}}</span>-->
<!--						</div>-->
<!--					</div>-->
					<div class="mt-30 rounded-20 bg-white/10 py-30 flex items-center justify-center">
						<div>
							<div class="flex items-center justify-center">
								<span class="text-24 text-#999">{{$t('ROON锁仓.将提取到钱包')}}</span>
							</div>
							<div class="flex items-start justify-center mt-20">
								<div class="text-center">
									<div>
										<span class="text-50 font-bold" style="color: #EB470C">{{withdrawal_number}}</span>
									</div>
									<div>
										<span class="text-26 " style="color: #EB470C">ROON</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-center">
						<div @click="withdrawal"
							class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
							<span class="text-32 text-white">{{$t('ROON锁仓.立即提取')}}</span>
						</div>
					</div>
				</div>
				<div class="mt-30 bg-white/10 p-30 rounded-20">
					<div class="">
						<span class="text-36 text-white font-bold">{{$t("ROON锁仓.锁仓说明")}}</span>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 flex items-center p-20">
						<div class="w-70 h-70">
							<img class="w-full h-full" src="@/assets/images/pages/lock/sm1.png" alt="" />
						</div>
						<div class="ml-20">
							<div>
								<span class="text-24 text-white">{{$t("ROON锁仓.线性解锁")}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#999">{{$t("ROON锁仓.闪兑获得的ROON将按照固定周期线性")}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 flex items-center p-20">
						<div class="w-70 h-70">
							<img class="w-full h-full" src="@/assets/images/pages/lock/sm2.png" alt="" />
						</div>
						<div class="ml-20">
							<div>
								<span class="text-24 text-white">{{$t("ROON锁仓.随时提取")}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#999">{{$t("ROON锁仓.已解锁的ROON可随时提取到钱包，无需等待")}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 flex items-center p-20">
						<div class="w-70 h-70">
							<img class="w-full h-full" src="@/assets/images/pages/lock/sm3.png" alt="" />
						</div>
						<div class="ml-20">
							<div>
								<span class="text-24 text-white">{{$t("ROON锁仓.安全保障")}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#999">{{$t("ROON锁仓.智能合约锁仓，资金安全有保障")}}</span>
							</div>
						</div>
					</div>

				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="node"></menu-bar> -->
		</template>
		<template v-slot:popup>
			<van-popup v-model="showAmountPopup" position="center" round>
				<div class="w-690">
					<div class="flex items-center justify-center relative h-200">
						<img class="absolute w-200 h-200" style="z-index: 100;" src="@/assets/images/common/success.png"
							alt="" />
					</div>
					<div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30" style="margin-top: -98rem;">
						<div class="flex items-center justify-center mt-20">
							<span class="text-36 text-white">{{$t("ROON锁仓.提取成功")}}</span>
						</div>
						<div class="flex items-center justify-center mt-20">
							<span class="text-26 text-#999">{{$t("ROON锁仓.ROON已成功转入您的钱包")}}</span>
						</div>
						<div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">
							<span class="text-26 text-white">{{$t("ROON锁仓.提取金额")}}</span>
							<div class="flex items-center">
								<img class="w-40 h-40" src="@/assets/images/pages/swap/roon.png" alt="" />
								<span class="ml-20 text-36" style="color: #EB470C;">100 RGT</span>
							</div>
						</div>
						<div class="mt-40 flex items-center justify-center">
							<div @click="showAmountPopup = false" class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
								<span class="text-32 text-white">{{$t('ROON锁仓.确认')}}</span>
							</div>
						</div>
					</div>
				</div>

			</van-popup>


			<!-- 质押 解押 -->
			 <van-popup v-model="jiepop" position="bottom" @close="jiepop=false">
				<div class="jiepopview">
					<div class="jieone">
						<span class="xname">{{$t('选择NFT解押')}}</span>
						<img src="@/assets/images/common/icon_gb.png" @click="jiepop=false" class="icon_gb" alt="">
					</div>
					<div class="dqian">
						<img src="@/assets/images/common/jiebg.png" class="jiebg" alt="">
						<div class="dqnavs">
							<img src="@/assets/images/common/hguan.png" class="hguan" alt="">
							<div class="dright">
								<span class="djie">{{$t('当前节点等级:黄金')}}{{node_name}}</span>
<!--								<span class="djietwo">{{$t('jiemiao')}}</span>-->
							</div>
						</div>
					</div>
					<span class="yixuan">质押中<span class="yixuannum">({{nft_staking_count}}{{$t('个')}}NFT)</span></span>
					<div class="plist">
						<div class="pitem" v-for="(item,index) in nft_stakings" :key="index">
							<img src="@/assets/images/common/img_logo.png" class="img_logoimg" alt="">
							<div class="pnav">
								<div class="pnavone">
									<span class="pnavname">{{item.token.name}}</span>
									<span class="pnabiao">#{{item.token.id}}</span>
<!--									<div class="bqitem">-->
<!--										<div class="bqnav">Level3-{{$t('黄金')}}</div>-->
<!--									</div>-->
								</div>
								<div class="jieyabtnnew" @click="extract(item)">{{$t('解押')}}</div>
							</div>
						</div>
					</div>
				</div>

			</van-popup>

			 <van-popup v-model="zhiyapop" position="bottom" @close="zhiyapop=false">
				<div class="jiepopview">
					<div class="jieone">
						<span class="xname">{{$t('选择NFT质押')}}</span>
						<img src="@/assets/images/common/icon_gb.png" @click="zhiyapop=false" class="icon_gb" alt="">
					</div>
					<div class="dqian">
						<img src="@/assets/images/common/jiebg.png" class="jiebg" alt="">
						<div class="dqnavs">
							<img src="@/assets/images/common/hguan.png" class="hguan" alt="">
							<div class="dright">
								<span class="djie">{{$t('当前节点等级:黄金')}}{{node_name}}</span>
<!--								<span class="djietwo">{{$t('zhimiao')}}</span>-->
							</div>
						</div>
					</div>
					<span class="yixuan">拥有<span class="yixuannum">({{nft_count}}{{$t('个')}}NFT)</span></span>
					<div class="plist">
						<div class="pitem" v-for="(item,index) in nfts" :key="index">
							<img :src="item.img" class="img_logoimg" alt="">
							<div class="pnav">
								<div class="pnavone">
									<span class="pnavname">{{item.name}}</span>
									<span class="pnabiao">#{{item.id}}</span>
									<div class="bqitem">
										<div class="bqnav">余额：{{item.balance}}</div>
									</div>
								</div>
                                <div class="jieyabtnnew" @click="staking(item)">质押</div>
							</div>
						</div>
					</div>
				</div>

			</van-popup>

            <!-- Loading Popup -->
            <van-popup v-model="loadingPopup" :close-on-click-overlay="false" style="background-color: transparent;">
                <div class="flex flex-col items-center justify-center p-30 rounded-20" style="background-color: rgba(0,0,0,0.8);">
                    <van-loading type="spinner" color="#EB470C" size="40px" />
                    <span class="mt-20 text-white text-28">{{$t('加载中...')}}</span>
                </div>
            </van-popup>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
    import nodeNft from "@/abi/nodeNftAbi";
    import SimpleERC1155StakingAbi from "@/abi/SimpleERC1155StakingAbi"
	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
                nft_stakings: [],
				queryInfo: {
					page: 1,
					type: 1
				},
				min_number: 0,
                already_roon: 0,
                withdrawal_roon_number: "0.002",
                roon: 0,
                roon_balance: 0,
                all_surplus_roon: 0,
                nft_count: 0,
                nft_staking_count: 0,
                node_name: "",
				mining_contract: "",
				last_pledge_usdt: "",
                withdrawal_number: "",
				last_pledge_name: "",
				address: "",
				show_address: "",
				order_id: "",
				users_id: "",
                total_address: "",
				contract_address: "0xf3708a77ea0282de751244194c304554d5a5d7ed",
				usdt_address: "0x55d398326f99059fF775485246999027B3197955",
                nft_staking_address: "0xC8b9755f01ccc17922a76c201cBE4Ef3e088b22F",
                nft_address: "0x027e7dE1469E0fd88e5EE4b5AebB596a0cb7e1C6",
				web3Provider: null,
				web3: null,
				list: [],
                nfts: [],
				amountList: [],
				showAmountPopup: false,
				canGo: true,
				form: {
					type: 1,
					amount: 0,
					amount_id: 0
				},
				// 是否购买
				isBuy: true,
				numberList: [{
						id: 1,
						num: "20%"
					},
					{
						id: 2,
						num: "50%"
					},
					{
						id: 3,
						num: "75%"
					},
					{
						id: 4,
						num: "100%"
					},
				],
				jiepop:false,
				zhiyapop:false,
				poptype:1,//1解压 2质押
                loadingPopup: false,
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
			activeType() {
				let item = {};
				item = this.typeList.find(item => item.id == this.queryInfo.type) || {};
				return item;
			},
			activeAmount() {
				let item = {};
				item = this.amountList.find(item => item.id == this.form.amount_id) || {};
				return item;
			}
		},
		created() {
			let vm = this
			if (window.ethereum) {
				vm.web3Provider = window.ethereum
				vm.web3 = new Web3(vm.web3Provider);
			}
			vm.getList();
		},
		methods: {
			getList() {
				let vm = this
				getShowAddress()
				ajaxData("/rgt/swap/lock").then(res => {
					console.log(res)
                    vm.address = res.data.address;
                    vm.total_address = res.data.total_address;
                    vm.withdrawal_roon_number = res.data.withdrawal_roon_number;
                    vm.already_roon = res.data.already_roon;
                    vm.roon = res.data.roon;
                    vm.roon_balance = res.data.roon_balance;
                    vm.all_surplus_roon = res.data.all_surplus_roon;
                    vm.node_name = res.data.node_name;
                    vm.nfts = res.data.nfts;
                    vm.nft_stakings = res.data.nft_stakings;
                    vm.nft_staking_count = vm.nft_stakings.length;

                    vm.getUserNfts()
				})
			},
            async extract(item) {
                const vm = this;
                if (!vm.web3) return;
                if (!vm.address) return;

                vm.paying = true;
                vm.loadingPopup = true;
                try {
                    // 先调用后端接口，成功后再继续链上交易
                    try {
                        const resp = await ajaxData("/nft/remove", { id: item.id });
                        console.log("/nft/remove resp", resp);
                    } catch (apiErr) {
                        console.error("/nft/remove error", apiErr);
                        vm.$message.error(apiErr?.message || vm.$t("吐司.操作失败"));
                        vm.paying = false;
                        vm.loadingPopup = false;
                        return; // 接口异常直接结束，不继续链上操作
                    }

                    const stakingContract = new vm.web3.eth.Contract(SimpleERC1155StakingAbi, vm.nft_staking_address);
                    await stakingContract.methods.unstake(item.stake_id).send({
                        from: vm.address
                    });

                    vm.$message.success("操作成功，请稍后刷新查看")
                    vm.jiepop = false
                    // Refresh data
                    vm.getList();
                } catch (e) {
                    console.error("Unstaking error:", e);
                } finally {
                    vm.paying = false;
                    vm.loadingPopup = false;
                }
            },
            async staking(item) {
                const vm = this;
                if (!vm.web3) return;
                if (!vm.address) return;


                vm.paying = true;
                vm.loadingPopup = true;
                try {
                    // 1. Check if approved
                    const nftContract = new vm.web3.eth.Contract(nodeNft, vm.nft_address);
                    const isApproved = await nftContract.methods.isApprovedForAll(vm.address, vm.nft_staking_address).call();

                    if (!isApproved) {
                        await nftContract.methods.setApprovalForAll(vm.nft_staking_address, true).send({
                            from: vm.address
                        });
                    }

                    // 2. Call stake
                    const stakingContract = new vm.web3.eth.Contract(SimpleERC1155StakingAbi, vm.nft_staking_address);
                    await stakingContract.methods.stake(item.id, 1, 2).send({
                        from: vm.address
                    });

                    vm.$message.success("操作成功，请稍后刷新查看")
                    vm.zhiyapop = false
                    // Refresh data
                    vm.getList();
                } catch (err) {
                    if (err.message) {
                        vm.$message.error(err.message);
                    } else {
                        vm.$message.error("Failed to fetch user NFTs");
                    }
                    console.error("Staking error:", err);
                } finally {
                    vm.paying = false;
                    vm.loadingPopup = false;
                }
            },
            async withdrawal(){
                const vm = this;
                try {
                    const num = parseFloat(vm.withdrawal_number);
                    if (!Number.isFinite(num) || num <= 0) {
                        vm.$message.error("请先输入金额");
                        return;
                    }

                    if (!vm.web3 || !vm.address) {
                        vm.$message.error(utils.$t("吐司.请在钱包中打包"));
                        return;
                    }

                    // 校验当前网络是否为 ROON 主链（chainId = 1314520）
                    const currentChainId = await vm.web3.eth.getChainId().catch(() => null);
                    if (currentChainId !== 1492) {
                        vm.$message.error("请切换到 ROON 主链");
                        return;
                    }

                    // 统一从钱包拉取当前账户，兼容 TokenPocket/MetaMask/OKX
                    let walletAccount = null;
                    try {
                        if (window?.ethereum?.request) {
                            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        } else {
                            const accounts = await vm.web3.eth.getAccounts();
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        }
                    } catch (e) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    if (!walletAccount) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    // 使用钱包当前账户作为交易发起方
                    vm.address = walletAccount;

                    // 纯地址转账：仅 from/to/value，不携带任何合约数据
                    const recipient = vm.total_address;
                    if (!recipient) {
                        vm.$message.error(utils.$t("吐司.收款地址无效"));
                        return;
                    }
                    let amountEth = parseFloat(vm.withdrawal_roon_number);
                    const weiValue = vm.web3.utils.toWei(amountEth.toString(), 'ether');

                    let field = "roon_balance"

                    vm.$message.success(utils.$t("吐司.请在钱包确认交易"));
                    // 开启不可关闭的 Loading 遮罩
                    vm.loadingPopup = true;

                    // 一些钱包（如 TokenPocket）对于 gas/gasPrice 更为严格，尽量显式提供
                    let gasPriceHex;
                    try {
                        const gasPrice = await vm.web3.eth.getGasPrice();
                        gasPriceHex = vm.web3.utils.toHex(gasPrice);
                    } catch {
                        gasPriceHex = vm.web3.utils.toHex(vm.web3.utils.toWei('63', 'gwei'));
                    }
                    let gasLimitHex;
                    try {
                        const gas = await vm.web3.eth.estimateGas({ from: vm.address, to: recipient, value: weiValue });
                        gasLimitHex = vm.web3.utils.toHex(gas);
                    } catch {
                        gasLimitHex = vm.web3.utils.toHex(21000);
                    }

                    const txParams = {
                        from: vm.address,
                        to: recipient,
                        value: vm.web3.utils.toHex(weiValue),
                        gasPrice: gasPriceHex,
                        gas: gasLimitHex,
                    };

                    // 使用事件回调：在拿到交易哈希时关闭 loading
                    vm.web3.eth.sendTransaction(txParams)
                        .on('transactionHash', (hash) => {
                            console.log('交易哈希:', hash);

                            ajaxData("/withdrawal/new",{
                                number:num,
                                field:field,
                                hash:hash,
                            }).then(res => {
                                console.log(res)
                                vm.withdrawal_number = ""
                                vm.$message.success("提现成功");
                                vm.loadingPopup = false
                                vm.getList()
                            }).catch(err => {
                                console.error(err);
                                vm.$message.error(err?.message || "提现失败");
                            }).finally(() => {
                                // 接口有响应（成功或失败）后关闭 Loading
                                vm.loadingPopup = false;
                            })
                        })
                        .on('receipt', (receipt) => {
                            console.log('主币支付成功:', receipt?.transactionHash || receipt);
                        })
                        .on('error', (error) => {
                            vm.loadingPopup = false;
                            console.error('交易失败:', error);
                            vm.$message.error("交易失败");
                        });

                } catch (err) {
                    // 输出更详细的 RPC 错误信息，便于定位问题
                    const original = err?.data?.originalError?.message || err?.data?.message || err?.message;
                    console.error('交易失败:', err);
                    vm.$message.error(original || utils.$t("吐司.操作失败"));
                    vm.loadingPopup = false;
                }
            },
            handleWithdrawalInput(){
                const vm = this;
                let val = String(vm.withdrawal_number ?? "");
                // 仅保留数字和小数点
                val = val.replace(/[^\d.]/g, '');
                // 仅保留第一个小数点
                const dotIndex = val.indexOf('.');
                if (dotIndex !== -1) {
                    val = val.slice(0, dotIndex + 1) + val.slice(dotIndex + 1).replace(/\./g, '');
                }
                // 若以小数点开头，补零
                if (val.startsWith('.')) val = '0' + val;
                vm.withdrawal_number = val;
            },
            async getUserNfts() {
                const vm = this;
                try {
                    if (!vm.web3) {
                        console.warn('Web3 provider is not initialized.');
                        return;
                    }
                    if (!vm.nft_address) {
                        console.warn('Contract address is missing.');
                        return;
                    }
                    const contract = new vm.web3.eth.Contract(nodeNft, vm.nft_address);
                    // console.log("vm.address",vm.address)
                    const data = await contract.methods.getUserNodes(vm.address).call();
                    console.log('getUserNodes result:', data);
                    const nodeIds = (data && (data.nodeIds || data[0])) || [];
                    const amounts = (data && (data.amounts || data[1])) || [];

                    // Create a map for easier lookup: id -> balance
                    let balanceMap = {};
                    for (let i = 0; i < nodeIds.length; i++) {
                        balanceMap[String(nodeIds[i])] = amounts[i];
                    }

                    let totalCount = 0;

                    // Filter and update existing nfts from API
                    if (vm.nfts && vm.nfts.length > 0) {
                        vm.nfts = vm.nfts.map(item => {
                            // Map balance using item.id, defaulting to 0 if not found
                            const balance = balanceMap[String(item.id)];
                            item.balance = balance ? balance.toString() : '0';
                            return item;
                        }).filter(item => Number(item.balance) > 0);

                        // Calculate total count based on filtered items
                        vm.nfts.forEach(item => {
                            totalCount += Number(item.balance);
                        });
                    }

                    vm.nft_count = totalCount;
                    console.log("nfts", vm.nfts);
                } catch (err) {
                    console.error('Failed to fetch user NFTs from contract:', err);
                    // if (err.message) {
                    //     vm.$message.error(err.message);
                    // } else {
                    //     vm.$message.error("Failed to fetch user NFTs");
                    // }
                }

            },
			async getUserNodePurchaseStatus() {
				const vm = this;
				const contract = new vm.web3.eth.Contract(Mining_Abi, vm.mining_contract);
				let data = await contract.methods.getUserNodePurchaseStatus(vm.address).call();
				console.log(data)
				console.log(data.nodeCount)
			},
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			selectAmount(item) {
				this.form.amount = item.number;
				this.form.amount_id = item.id;
				this.showAmountPopup = false;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			},
			getjieyaClick(e){
				this.poptype = e
				if(e == 1){
					this.jiepop = true
				}else{
					this.zhiyapop = true
				}
			}
		},
	};
</script>

<style scoped>
	.lock-item1-bg-image {
		width: 690rem;
		height: 240rem;
		background-image: url("~@/assets/images/pages/lock/bannerBg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.lock-item2-bg-image {
		background-image: url("~@/assets/images/pages/lock/item1Bg.png");
		background-size: 662rem 176rem;
		background-repeat: no-repeat;
		background-position: bottom;
	}

	.jieya{
		display: flex;
		flex-direction: row;
		margin-top: 15px;
	}
	.jieyabtn{
		height: 50px;
		background: rgba(235, 71, 12,0.2);
		border-radius: 25px;
		display: flex;
		width: 48%;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 16px;
		color: #EB470C;
	}
	.zhiya{
		margin-left: auto;
		background: #EB470C;
		color: #fff;
	}
	.jiepopview{
		background: #19191A;
		border-radius: 15px 15px 0px 0px;
		padding: 20px;
	}
	.jieone{
		display: flex;
		flex-direction: row;
		align-items: center;

	}
	.xname{
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
	}
	.icon_gb{
		margin-left: auto;
		width: 16px;
		height: 16px;

	}
	.dqian{

		background: #3C3106;
		border-radius: 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin: 20px 0;
		position: relative;
	}
	.dqnavs{
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 15px 15px;
		width: 100%;
	}
	.jiebg{
		position: absolute;
		width: 100%;
		height: 100%;
	}
	.hguan{
		width: 44px;
		height: 44px;
		margin-right: 10px;
	}
	.dright{
		width: 70%;
		display: flex;
		flex-direction: column;
	}
	.djie{
		font-weight: bold;
		font-size: 14px;
		color: #FFFFFF;
	}
	.djietwo{
		font-weight: 400;
		font-size: 12px;
		color: #999999;
		display: block;
		margin-top: 10px;
	}
	.yixuan{
		display: block;
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 20px;
		margin-bottom: 20px;
	}
	.yixuannum{
		font-weight: bold;
		font-size: 16px;
		display: inline-block;
		margin-left: 4px;
		color: #FFFFFF;
	}
	.plist{
		overflow-y: scroll;
		max-height: 300px;
	}
	.pitem{
		background: #262626;
		border-radius: 10px;
		border: 0.5px solid #EB470C;
		padding: 10px;
		display: flex;
		flex-direction: row;
		margin-bottom: 15px;
	}
	.pitem:last-child{
		margin-bottom: 0;
	}
	.img_logoimg{
		width: 60px;
		height: 60px;
		margin-right: 10px;
	}
	.pnav{
		width: 78%;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.pnavone{
		display: flex;
		flex-direction: column;

	}
	.pnavname{
		font-weight: 500;
		font-size: 15px;
		color: #FFFFFF;
	}
	.pnabiao{
		font-weight: 500;
		font-size: 10px;
		color: #999999;
		display: block;
		margin: 6px 0;
	}
	.bqitem{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.bqnav{
		padding: 2px 6px;
		background: rgba(235,71,12,0.2);
		border-radius: 3px;
		border: 1px solid #FF902D;
		font-weight: 400;
		font-size: 10px;
		color: #FF902D;
	}
	.quan{
		width: 18px;
		height: 18px;
		margin-left: auto;
	}
	.bot{
		padding: 20px 0 0;
	}
	.zhibtn{
		height: 50px;
		background: #EB470C;
		border-radius: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
	}
	.jieyabtnnew{
		margin-left: auto;
		height: 40px;
		background: #EB470C;
		border-radius: 10px;
		display: flex;
		padding: 0 25px;

		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 14px;
		color: #FFFFFF;
	}

</style>











